import React, { useState, useEffect } from "react";
import axios from "axios";
import Pengaturan from "./components/pengaturan";
import { Modal, Button } from "react-bootstrap";
function Dashboard() {
  //const [user, setUser]=useState({});
  const [user, setUser] = useState();
  const token = localStorage.getItem("token");
  const [show, setShow] = useState(false);
  const [showError, setShowError] = useState(false);
  const [judulError, setJudulError] = useState("");
  const [btnError, setBtnError] = useState("");
  const [pesanError, setPesanError] = useState("");
  const errorShow = () => setShowError(true);
  const errorClose = () => setShowError(false);
  let pesan_error = [];
  const fetchData = async () => {
    setPesanError("Memuat data scheduler...");
    errorShow();
    axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    await axios
      .get(
        Pengaturan["urlApi"] +
          "pullscheduler" +
          "?router=" +
          localStorage.getItem("rtr")
      )
      .then((response) => {
        errorClose();
      })
      .catch((error) => {
        setPesanError("Gagal memuat data scheduler");
      });
    setPesanError("Memuat data secret...");
    errorShow();
    await axios
      .get(
        Pengaturan["urlApi"] +
          "pullsecret" +
          "?router=" +
          localStorage.getItem("rtr")
      )
      .then((response) => {
        errorClose();
      })
      .catch((error) => {
        setPesanError("Gagal memuat data secret");
      });
  };
  const closeError = () => {
    pesan_error.length = 0;
    setShowError(false);
  };
  useEffect(() => {
    fetchData();
  }, []);

  return (
    <>
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-md-6" style={{ marginTop: "10px" }}>
            <Button
              href={Pengaturan["baseurl"] + "billing"}
              style={{ width: "100%" }}
            >
              Billing
            </Button>
          </div>
          <div className="col-md-6" style={{ marginTop: "10px" }}>
            <Button
              href={Pengaturan["baseurl"] + "customer"}
              style={{ width: "100%" }}
            >
              Customer
            </Button>
          </div>
          <div className="col-md-6" style={{ marginTop: "10px" }}>
            <Button
              href={Pengaturan["baseurl"] + "pppsecret"}
              style={{ width: "100%" }}
            >
              PPP - Secret
            </Button>
          </div>
          <div className="col-md-6" style={{ marginTop: "10px" }}>
            <Button
              href={Pengaturan["baseurl"] + "activeconnection"}
              style={{ width: "100%" }}
            >
              PPP - Active Connection
            </Button>
          </div>
        </div>
      </div>
      <Modal
        show={showError}
        onHide={errorClose}
        backdrop="static"
        keyboard={false}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>{judulError}</Modal.Title>
        </Modal.Header>
        <Modal.Body>{pesanError}</Modal.Body>
        <Modal.Footer>
          {btnError}
          <Button variant="secondary" onClick={closeError}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
export default Dashboard;
